import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { TextVariant } from './constants.ts';
import { StyledErrorIcon } from './ErrorIcon.styled.tsx';
import { getLoadingMediaErrorMsg } from './utils.ts';

type IconWithTooltipProps = {
  iconSize: number;
};

export function IconWithTooltip({ iconSize }: IconWithTooltipProps) {
  const { t } = useTranslation();

  return (
    <Tooltip title={<Typography variant="caption">{getLoadingMediaErrorMsg(t)}</Typography>} placement="top-start">
      <StyledErrorIcon width={iconSize} height={iconSize} paddingVariant={TextVariant.None} isPointer={true} />
    </Tooltip>
  );
}
